import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Movido verbatim de apps/web/src/lib/utils.ts (Sprint 5, TUT-211). O `cn`
// é resolução de conflito de classes: `tailwind-merge` em versão diferente
// da do app mudaria o resultado sem nenhum diff de markup — por isso as
// versões deste package espelham as do apps/web.
//
// TUT-563a (Lumen 2.0) — os seis tokens da escala de tipo (`base.css`,
// `@theme static`) são TAMANHO de letra. Sem registrá-los, o `tailwind-merge`
// lia `text-legenda` como cor e apagava o `text-foreground` vizinho (ou o
// contrário). A prova é `utils.test.ts`.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["legenda", "corpo", "destaque", "subtitulo", "titulo", "titulo-pagina", "titulo-entrada"],
      // O peso do botão (`--font-weight-botao`, 550): peso, e não família.
      "font-weight": ["botao"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
